<script>
export default {
  name: 'AccordionDivider',
  props: {
    scale: {
      type: Number,
      default: 1
    },
    color: {
      type: String,
      default: 'black'
    }
  },
  computed: {
    styles () {
      return {
        divider: {
          '--background-color': this.color,
          '--scale': this.scale
        }
      }
    }
  }
}
</script>

<template>
  <div
    class="accordion-divider"
    :style="styles.divider"
  />
</template>

<style lang="scss" scoped>
.accordion-divider {
  width: 100%;
  height: calc(3px * var(--scale));
  background-color: var(--background-color);
}
</style>
